import transactionSession from '../instance';

const getTransactionSession = () => transactionSession.get();

export default getTransactionSession;
